/*
 * Copyright (c) Schrocken Inc.
 * Author: Harish
 * File Description: Actions file for login user
 */

/* eslint-disable no-console */

import axios from 'axios';

import { appUrl, smlUrl } from '../../utils/config';


import { deleteAuthToken } from '../../utils/setAuthToken';

import {
   FETCH_NETWORK_TYPES,
   FETCH_NETWORK_TYPES_LOADING,
   FETCH_COLLABORATOR_TYPE,
   FETCH_COLLABORATOR_TYPE_LOADING,
   UPDATE_NETWORK_DETAILS,
   UPDATE_PARTNER_DETAILS,
   ADD_NETWORK_DETAILS,
   ADD_PARTNER_DETAILS,
   DELETE_NETWORK_TYPE,
   DELETE_PARTNER_TYPE,
   GET_NETWORK_ROLES,
   GET_NETWORK_ROLES_LOADING,
   ADD_SPONSOR_NETWORK_DETAILS,
   FETCH_ALL_SPONSOR_NETWORKS,
   FETCH_ALL_SPONSOR_NETWORKS_LOADING,
   FETCH_SELECTED_SPONSOR_DETAILS_LOADING,
   FETCH_SELECTED_SPONSOR_DETAILS,
   SEND_NETWORK_INVITATION,
   UPDATE_SPONSOR_NETWORK_DETAILS,
   SAVE_NETWORK_CONFIGURATION_PROGRESS
} from './types';

import {
    OPEN_BACKDROP,
    DESTROY_BACKDROP
} from '../../components/pcmp/containers/actions/types';


export const fetchNetworkType = (ecosystemID) => (dispatch) => {
  axios
    
    //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDepartmentDetails`)
    .get(`${smlUrl}/admin/fetchNetworkTypes/${ecosystemID}`)
    .then((res) => {
      dispatch({
        type: FETCH_NETWORK_TYPES_LOADING,
        payload: false,
      });
      dispatch({
        type: FETCH_NETWORK_TYPES,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err?.response?.status === 404) {
        dispatch({
          type: FETCH_NETWORK_TYPES_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_NETWORK_TYPES,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: FETCH_NETWORK_TYPES_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_NETWORK_TYPES,
          payload: {
            status: false,
            errorDescription:
              'Something went wrong. Please contact Schrocken Support.',
          },
        });
      }
    });
};


export const fetchCollaboratorType = (ecosystemID) => (dispatch) => {
    axios
      
      //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDepartmentDetails`)
      .get(`${smlUrl}/admin/fetchPartnerTypes/${ecosystemID}`)
      .then((res) => {
        dispatch({
          type: FETCH_COLLABORATOR_TYPE_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_COLLABORATOR_TYPE,
          payload: res.data,
        });
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          dispatch({
            type: FETCH_COLLABORATOR_TYPE_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_COLLABORATOR_TYPE,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: FETCH_COLLABORATOR_TYPE_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_COLLABORATOR_TYPE,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact Schrocken Support.',
            },
          });
        }
      });
  };

export const updateNetworkType = (data) => (dispatch) => {
  dispatch({
    type: OPEN_BACKDROP,
    backdropText: `Please don't refresh or close the tab while processing`,
  });
  axios
    .post(`${smlUrl}/admin/updateNetworkType`, data)
    // .post(
    //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDepartmentDetails`, data)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_NETWORK_DETAILS,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      if (err?.response?.status === 400) {
        console.log('err', err.response.data);
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_NETWORK_DETAILS,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_NETWORK_DETAILS,
          payload: {
            status: false,
            errorDescription:
              'Something went wrong. Please contact schrocken support.',
          },
        });
      }
    });
};


export const updatePartnerType = (data) => (dispatch) => {
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: `Please don't refresh or close the tab while processing`,
    });
    axios
      .post(`${smlUrl}/admin/updatePartnerType`, data)
      // .post(
      //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDepartmentDetails`, data)
      .then((res) => {
        if (res.data.status === true) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: UPDATE_PARTNER_DETAILS,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.status === 400) {
          console.log('err', err.response.data);
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: UPDATE_PARTNER_DETAILS,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: UPDATE_PARTNER_DETAILS,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact schrocken support.',
            },
          });
        }
      });
  };


  export const addNetworkType = (data) => (dispatch) => {
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: `Please don't refresh or close the tab while processing`,
    });
    axios
      .post(`${smlUrl}/admin/addNetworkType`, data)
      // .post(
      //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDepartmentDetails`, data)
      .then((res) => {
        if (res.data.status === true) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: ADD_NETWORK_DETAILS,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.status === 400) {
          console.log('err', err.response.data);
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: ADD_NETWORK_DETAILS,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: ADD_NETWORK_DETAILS,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact schrocken support.',
            },
          });
        }
      });
  };

  export const addPartnerType = (data) => (dispatch) => {
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: `Please don't refresh or close the tab while processing`,
    });
    axios
      .post(`${smlUrl}/admin/addPartnerType`, data)
      // .post(
      //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDepartmentDetails`, data)
      .then((res) => {
        if (res.data.status === true) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: ADD_PARTNER_DETAILS,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.status === 400) {
          console.log('err', err.response.data);
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: ADD_PARTNER_DETAILS,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: ADD_PARTNER_DETAILS,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact schrocken support.',
            },
          });
        }
      });
  };

  export const deleteNetworkType = (data) => (dispatch) => {
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: `Please don't refresh or close the tab while processing`,
    });
    axios
      .post(`${smlUrl}/admin/deleteNetworkType`, data)
      // .post(
      //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDepartmentDetails`, data)
      .then((res) => {
        if (res.data.status === true) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: DELETE_NETWORK_TYPE,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.status === 400) {
          console.log('err', err.response.data);
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: DELETE_NETWORK_TYPE,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: DELETE_NETWORK_TYPE,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact schrocken support.',
            },
          });
        }
      });
  };


  export const deletePartnerType = (data) => (dispatch) => {
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: `Please don't refresh or close the tab while processing`,
    });
    axios
      .post(`${smlUrl}/admin/deletePartnerType`, data)
      // .post(
      //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDepartmentDetails`, data)
      .then((res) => {
        if (res.data.status === true) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: DELETE_PARTNER_TYPE,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.status === 400) {
          console.log('err', err.response.data);
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: DELETE_PARTNER_TYPE,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: DELETE_PARTNER_TYPE,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact schrocken support.',
            },
          });
        }
      });
  };


  export const getNetworkRoles = ( {ecosystemId,network,ecosystemUrl} ) => (dispatch) => {
    axios
      
      //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDepartmentDetails`)
      .get(
              `${ecosystemUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/getNetworkRoles/${ecosystemId}`)
        // `https://mosymphony-dev.collabrix.co/Pharma%20Contract%20Manufacturing/N1/sh1/Pharma%20Co/Admin/getNetworkRoles/${ecosystemId}`)
      .then((res) => {
        dispatch({
          type: GET_NETWORK_ROLES_LOADING,
          payload: false,
        });
        dispatch({
          type: GET_NETWORK_ROLES,
          payload: res.data,
        });
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          dispatch({
            type: GET_NETWORK_ROLES_LOADING,
            payload: false,
          });
          dispatch({
            type: GET_NETWORK_ROLES,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: GET_NETWORK_ROLES_LOADING,
            payload: false,
          });
          dispatch({
            type: GET_NETWORK_ROLES,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact Schrocken Support.',
            },
          });
        }
      });
  };

  export const addSponsorNetworkDetails = (data) => (dispatch) => {
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: `Please don't refresh or close the tab while processing`,
    });
    axios
      .post(`${smlUrl}/admin/addSponsorNetworkDetails`, data)
      // .post(
      //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDepartmentDetails`, data)
      .then((res) => {
        if (res.data.status === true) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: ADD_SPONSOR_NETWORK_DETAILS,
            payload: res.data,
          });
            // console.log("addSponsor API response:", res.data); 
        }
      })
      .catch((err) => {
        if (err?.response?.status === 400) {
          console.log('err', err.response.data);
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: ADD_SPONSOR_NETWORK_DETAILS,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: ADD_SPONSOR_NETWORK_DETAILS,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact schrocken support.',
            },
          });
        }
      });
  };


  export const fetchAllSponsorNetworks = (data) => (dispatch) => {
    axios
      
      //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDepartmentDetails`)
      .post(`${smlUrl}/admin/fetchAllSponsorNetworks`,data)
      .then((res) => {
        dispatch({
          type: FETCH_ALL_SPONSOR_NETWORKS_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_ALL_SPONSOR_NETWORKS,
          payload: res.data,
        });
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          dispatch({
            type: FETCH_ALL_SPONSOR_NETWORKS_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_ALL_SPONSOR_NETWORKS,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: FETCH_ALL_SPONSOR_NETWORKS_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_ALL_SPONSOR_NETWORKS,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact Schrocken Support.',
            },
          });
        }
      });
  };



  export const fetchSelectedSponsorDetails = (data) => (dispatch) => {
    axios
      
      //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDepartmentDetails`)
      .post(`${smlUrl}/admin/fetchSelectedSponsorDetails`,data)
      .then((res) => {
        dispatch({
          type: FETCH_SELECTED_SPONSOR_DETAILS_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_SELECTED_SPONSOR_DETAILS,
          payload: res.data,
        });
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          dispatch({
            type: FETCH_SELECTED_SPONSOR_DETAILS_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_SELECTED_SPONSOR_DETAILS,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: FETCH_SELECTED_SPONSOR_DETAILS_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_SELECTED_SPONSOR_DETAILS,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact Schrocken Support.',
            },
          });
        }
      });
  };


  export const sendNetworkInvitation = (data) => (dispatch) => {
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: `Please don't refresh or close the tab while processing`,
    });
    // setTimeout(() => {
    //   dispatch({
    //     type: SEND_BRAND_OWNER_INVITATION_NEW,
    //     // payload: {
    //     //   status: false,
    //     //   errorMessage: "Authentication error",
    //     //   errorDescription: "Level1 authentication failed: Invalid Token",
    //     // },
  
    //     payload: {
    //       status: true,
    //       data: {
    //         organizationCode: 700001,
    //         orgName: "Schrocken Inc.",
    //         email: "sasank.avantsa@schrocken.com",
    //         ecosystemId: 2,
    //         message: "Email has been sent successfully.",
    //       },
    //     },
    //   });
    //   dispatch({
    //     type: DESTROY_BACKDROP,
    //   });
    // }, 5000);
    axios
      .post(`${smlUrl}/admin/sendNetworkInvitation`, data)
      .then((res) => {
        if (res.data.status === true) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: SEND_NETWORK_INVITATION,
            payload: res.data,
          });
          // axios
          //   .get(`${smlUrl}/admin/fetchEcosystems`)
          //   .then((response) => {
          //     if (response.data.status === true) {
          //       dispatch({
          //         type: GET_ECOSYSTEMS,
          //         payload: response.data,
          //       });
          //     }
          //   })
          //   .catch((err) => console.log(err));
        }
      })
      .catch((err) => {
        if (err?.response?.status === 400) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: SEND_NETWORK_INVITATION,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          dispatch({
            type: SEND_NETWORK_INVITATION,
            payload: {
              status: false,
              errorDescription: {
                error: "Something went wrong. Please contact schrocken support.",
              },
            },
          });
        }
      });
  };


  export const updateSponsorNetworkDetails = (data) => (dispatch) => {
  dispatch({
    type: OPEN_BACKDROP,
    backdropText: `Please don't refresh or close the tab while processing`,
  });

  axios
    .post(`${smlUrl}/admin/updateSponsorNetworkDetails`, data)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_SPONSOR_NETWORK_DETAILS,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      if (err?.response?.status === 400) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_SPONSOR_NETWORK_DETAILS,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_SPONSOR_NETWORK_DETAILS,
          payload: {
            status: false,
            errorDescription: {
              error: "Something went wrong. Please contact schrocken support.",
            },
          },
        });
      }
    });
};


export const saveNetworkConfigurationProgress = (data) => (dispatch) => {
  dispatch({
    type: OPEN_BACKDROP,
    backdropText: `Please don't refresh or close the tab while processing`,
  });
  axios
    .post(`${smlUrl}/admin/saveNetworkConfigurationProgress`, data)
    // .post(
    //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDepartmentDetails`, data)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: SAVE_NETWORK_CONFIGURATION_PROGRESS,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      if (err?.response?.status === 400) {
        console.log('err', err.response.data);
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: SAVE_NETWORK_CONFIGURATION_PROGRESS,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: SAVE_NETWORK_CONFIGURATION_PROGRESS,
          payload: {
            status: false,
            errorDescription:
              'Something went wrong. Please contact schrocken support.',
          },
        });
      }
    });
};